import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData,
  type BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError,
  type BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse,
  bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost,
} from '../../generated';

export type BulkRefreshPdpsMutationVariables = BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData['path'] &
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData['body'];

export type BulkRefreshPdpsMutation = BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse;

export const useBulkRefreshPdpsMutation = <
  TError = BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<BulkRefreshPdpsMutation, TError, BulkRefreshPdpsMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<BulkRefreshPdpsMutation, TError, BulkRefreshPdpsMutationVariables, TContext>({
    mutationKey: ['BulkRefreshPdps'],
    mutationFn: async ({ portfolio_id, ...body }: BulkRefreshPdpsMutationVariables) => {
      const { data } = await bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost({
        path: { portfolio_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useBulkRefreshPdpsMutation.fetcher = (
  { portfolio_id, ...body }: BulkRefreshPdpsMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost({
      path: { portfolio_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
